import React, { useRef, useState } from 'react';
import Loading from '../generalComponets/Loading';
import SelectUsers from './SelectUsers';
import { useFirestore } from 'react-redux-firebase';

function EnableTrivia() {
  const firestore = useFirestore();
  const [showProcess, setShowProcess] = useState(false);
  const childRef = useRef();

  const enableTrivia = async () => {
    try {
      setShowProcess(true);
      const profiles = childRef.current.getProfiles();
      if (profiles && profiles.length > 0) {
        const promises = [];
        const date = new Date();
        const minimumYear = date.getFullYear() - 1;
        const dateInit = new Date(`${minimumYear}/01/01`);
        const query = firestore.collection('userTrivia');
        profiles.forEach((profile) => {
          promises.push(query.doc(profile.id).update({ answerDate: dateInit }));
        });
        await Promise.all(promises);
      }
      setShowProcess(false);
    } catch (e) {
      console.log(e.message());
      setShowProcess(false);
    }
  };

  return (
    <div className="container">
      <div className="title-section">Enable Trivia</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col s6">
          <button className="btn" onClick={enableTrivia}>
            Enable Trivia
          </button>
        </div>
        <div className="col s6">
          <SelectUsers ref={childRef} triviaState={true} />
        </div>
      </div>
    </div>
  );
}

export default EnableTrivia;
